import { render } from "./Index-orderManagement.vue?vue&type=template&id=566baed1"
import script from "./Index-orderManagement.vue?vue&type=script&lang=js"
export * from "./Index-orderManagement.vue?vue&type=script&lang=js"

import "./Index-orderManagement.vue?vue&type=style&index=0&id=566baed1&lang=scss"

import exportComponent from "C:\\Users\\Yuting_Shiu\\Desktop\\mes-chunyu-modify\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__